<template>
  <div class="stat" :class="classFromColorIndex(colorIndex,'bg-primary', 'bg-secondary')">
    <div class="stat-number">
      <slot name="statNumber" />
    </div>
    <div class="stat-units">
      <slot name="statUnits" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    colorIndex: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style lang="scss" scoped>
.stat {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  color: white;
}

.stat-number {
  font-size: 20px;
  font-weight: 700;
}
</style>
